
import { Component, Vue } from "vue-property-decorator";
import * as QRCode from "@/utils/qrcode.js";
@Component
export default class Footer extends Vue {
  mounted() {
    new (QRCode.default as any)(this.$refs.qrcode, {
      width: 100,
      height: 100,
      colorDark: "#48d3b9",
      text: "http://app.mi.com/details?id=com.ty.tyclient&ref=search",
      logo: require("@/assets/logo-qrcode.jpg")
    });
  }
  render() {
    return (
      <div id="footer">
        <a-back-top></a-back-top>
        <div class="inner-content">
          <div class="footer-wrap">
            <div>
              <span>关于雷拓尔菲</span>
              <a-divider type="vertical" />
              <span>联系我们</span>
              <a-divider type="vertical" />
              <span>加入我们</span>
              <a-divider type="vertical" />
              <span>雷拓尔菲租房</span>
              <a-divider type="vertical" />
              <span>隐私声明</span>
              <a-divider type="vertical" />
              <span
                onClick={() => {
                  window.open("http://manage.tydc.top");
                }}
              >
                员工登录
              </span>
            </div>
            <div style="height:20px;"></div>
            <div style="display:flex;">
              <div>
                <div class="customer-phone">固话</div>
                <div class="phone">01058449190</div>
              </div>
              <div style="width:20px;"></div>
              <div>
                <div class="customer-phone">手机号</div>
                <div class="phone">18519048888</div>
              </div>
            </div>
            <div class="qrcode" ref="qrcode">
              <div class="dec">下载雷拓尔菲公寓App</div>
            </div>
          </div>
          <div style="height:20px;"></div>
          <div style="color:#bbb;">
            雷拓尔菲 Copyright©2020 tydc.top 版权所有 
          </div>
          <div style="color:#bbb;">地址：北京市朝阳区东坝中路28号院14</div>
        </div>
      </div>
    );
  }
}
